import React from 'react';

const Footer = () => (
  <footer style={{ background: '#eee', padding: '10px', textAlign: 'center' }}>
    <p>© 2025 Hygenic Agro</p>
  </footer>
);

export default Footer;
